export default {
    colors: {
        cobalt: '#236dd3',
        cobaltDark: '#1e5eb8',
        white: '#fff',
        oil: 'rgba(0,0,0,0.4)',
        smoke: 'rgba(255,255,255,.1)',
    },
    widths: {
        row: '65.5rem'
    },
    fonts: {
        color: '#fff',
        family: "'Muli', sans-serif",
        h1: {
            desktop: '2.75rem',
            tablet: '2.5rem',
            mobile: '2.25rem'
        },
        h2: {
            desktop: '2.25rem',
            tablet: '1.5rem',
            mobile: '1.25rem'
        },
    }
}